export const MODAL_NAME = "removeProjectLink";
